import { Component, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { Artist } from 'src/app/models/artist.model'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import { Title } from '@angular/platform-browser'
import { environment } from 'src/environments/environment'

@Component({
    selector: 'app-artist-combined',
    templateUrl: './artist-combined.component.html',
    styleUrls: ['./artist-combined.component.scss'],
    standalone: false
})
export class ArtistCombinedComponent implements OnInit {
  selectedArtist$: Observable<Artist>

  constructor(private store: Store<AppState>, private titleService: Title) {}

  ngOnInit() {
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.selectedArtist$.subscribe(artist =>
      this.titleService.setTitle(artist.nameMain + ' | ' + environment.title)
    )
  }
}
